<template>
    <div v-if="showOverlay" class="update-overlay">
      <div class="update-container">
        <img 
          v-if="tenantLogoBase64" 
          class="tenant-logo pulsing" 
          :src="tenantLogoBase64" 
          :alt="$t('common.tenantLogoAlt')" 
        />
        <h3>{{ $t('common.newVersionAvailable') }}</h3>
        <p>{{ $t('common.newVersionAvailableMessage') }}</p>
        <button @click="updateNow" class="update-button">
          {{ $t('common.ok') }}
        </button>
      </div>
    </div>
  </template>
  
  <script>
  import { computed, onMounted } from 'vue';
  import { useStore } from 'vuex';
  
  export default {
    props: {
      showOverlay: {
        type: Boolean,
        default: false
      }
    },

    emits: ['update'],

    setup(props, { emit }) {
      const store = useStore();
      const tenantLogoBase64 = computed(() => store.state.tenant.tenantinfo.tenantLogoBase64);
      
      onMounted(async () => {
        if (!tenantLogoBase64.value) {
          await store.dispatch('tenant/getTenantLogoBase64');
        }
      });
      
      // Signal the app to apply the pending update. The actual SKIP_WAITING /
      // reload is handled centrally in registerServiceWorker.js (applyUpdate).
      const updateNow = () => {
        emit('update');
      };
      
      return {
        tenantLogoBase64,
        updateNow
      };
    }
  }
  </script>
  
  <style scoped>
  .update-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(5px);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .update-container {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    padding: 30px;
    max-width: 400px;
    text-align: center;
  }
  
  .tenant-logo {
    width: 100px;
    height: auto;
    margin-bottom: 20px;
  }
  
  .pulsing {
    animation: pulse 2s infinite;
  }
  
  @keyframes pulse {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      transform: scale(1.1);
      opacity: 0.7;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
  
  h3 {
    margin-bottom: 15px;
    color: #333;
  }
  
  p {
    margin-bottom: 20px;
    color: #666;
  }
  
  .version-info {
    margin: 10px 0;
    color: #888;
    font-size: 0.9em;
  }

  .loading-spinner {
    margin: 20px 0;
    color: var(--primary-color, #4CAF50);
  }
  
  .update-button {
    background-color: var(--primary-color, #4CAF50);
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.2s;
  }
  
  .update-button:hover {
    background-color: var(--primary-color-hover, #45a049);
  }
  </style>